(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener("DOMContentLoaded", function () {
  require('./modules/nav.js');
  require('./modules/target-blank.js');
  require('./modules/slider.js');
  require('./modules/event-share.js');
  require('./modules/daterangepicker.js');
});

// remove preloader
window.addEventListener('load', function () {
  document.querySelector('html').classList.add('page-loaded');
});

},{"./modules/daterangepicker.js":2,"./modules/event-share.js":3,"./modules/nav.js":4,"./modules/slider.js":5,"./modules/target-blank.js":6}],2:[function(require,module,exports){
"use strict";

;
(function ($) {
  // vendors.js (moment + daterangepicker) is only enqueued on the events archive
  if (!$.fn.daterangepicker || !$('#daterange').length) return;
  $('#daterange').daterangepicker({
    singleDatePicker: false,
    autoUpdateInput: false,
    opens: 'right',
    showOutsideDays: false,
    locale: {
      format: 'DD.MM.YYYY',
      applyLabel: 'Apply',
      cancelLabel: 'Reset'
    }
  });
  $('#daterange').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('MMM. D, YYYY') + ' - ' + picker.endDate.format('MMM. D, YYYY'));
  });
  $('#daterange').on('cancel.daterangepicker', function (ev, picker) {
    $('#daterange').data('daterangepicker').setStartDate(moment().startOf('day'));
    $('#daterange').data('daterangepicker').setEndDate(moment().startOf('day'));
    $('#daterange').val('');
  });
})(jQuery);
function stickyInsideParent(childSelector, parentSelector) {
  var offsetTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var minWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1024;
  var child = document.querySelector(childSelector);
  var parent = document.querySelector(parentSelector);
  if (!child || !parent) return;
  function resetPosition() {
    child.style.position = 'static';
    child.style.top = 'auto';
    child.style.bottom = 'auto';
  }
  function updatePosition() {
    if (window.innerWidth < minWidth) {
      resetPosition();
      return;
    }
    var parentRect = parent.getBoundingClientRect();
    var childRect = child.getBoundingClientRect();
    if (parentRect.top <= offsetTop && parentRect.bottom > childRect.height + offsetTop) {
      child.style.position = 'fixed';
      child.style.top = offsetTop + 'px';
      child.style.bottom = 'auto';
    } else if (parentRect.bottom <= childRect.height + offsetTop) {
      child.style.position = 'absolute';
      child.style.top = 'auto';
      child.style.bottom = '0';
    } else {
      child.style.position = 'absolute';
      child.style.top = '0';
      child.style.bottom = 'auto';
    }
  }
  window.addEventListener('scroll', updatePosition);
  window.addEventListener('resize', updatePosition);
  updatePosition();
}
stickyInsideParent('.events-filter__filter', '.events-filter__filter-wrapper', 120, 768);

// The events filter only exists on the events archive; skip the rest of the setup elsewhere
var eventsFilter = document.querySelector('.events-filter__filter');
if (eventsFilter) {
  window.addEventListener('resize', function () {
    setMinHeight();
    if (window.innerWidth < 768) {
      eventsFilter.removeAttribute('open');
    } else {
      eventsFilter.setAttribute('open', true);
    }
  });
  if (window.innerWidth < 768) {
    eventsFilter.removeAttribute('open');
  }
  if (window.innerWidth > 768) {
    setMinHeight();
  }
}
function setMinHeight() {
  var wrapper = document.querySelector('.events-filter__filter-wrapper');
  if (!wrapper || !eventsFilter) return;
  wrapper.style.minHeight = eventsFilter.getBoundingClientRect().height + 'px';
}

},{}],3:[function(require,module,exports){
"use strict";

document.addEventListener('click', function (e) {
  if (e.target && e.target.classList.contains('calendar-share__button')) {
    var parent = e.target.closest('.calendar-share');
    if (parent.classList.contains('opened')) {
      parent.classList.remove('opened');
    } else {
      parent.classList.add('opened');
    }
  }
});

},{}],4:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
;
(function () {
  var submenuItems = document.querySelectorAll('.nav__item-has-children');
  var $menu = document.querySelector('.nav');
  var submenuItems1 = document.querySelectorAll('.nav ul > .nav__item-has-children');
  var _iterator = _createForOfIteratorHelper(submenuItems1),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var title = item.children[0].textContent;
      var linkHref = item.children[0].getAttribute('href');
      var node = document.createElement('li');
      var link = document.createElement('a');
      link.textContent = title;
      link.setAttribute('href', linkHref);
      node.classList.add('nav__submenu-title');
      item.querySelector('.nav__submenu').prepend(node);
      node.prepend(link);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(submenuItems),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _item = _step2.value;
      _item.addEventListener('click', function (e) {
        if (window.innerWidth < 1024) {
          if (!this.classList.contains('opened')) {
            e.stopPropagation();
            e.preventDefault();
            this.classList.add('opened');
            $menu.classList.add('submenu-opened');
          }
        }
      });
      _item.addEventListener('mouseenter', function (e) {
        if (window.innerWidth >= 1024) {
          if (!this.classList.contains('opened')) {
            if (this.parentElement.classList.contains('nav__submenu')) {
              var parentMenu = this.parentElement;
              var childrenMenu = this.querySelector('.nav__submenu');
              var freeSpace = window.outerWidth - parentMenu.getBoundingClientRect().right;
              if (freeSpace < childrenMenu.getBoundingClientRect().width) {
                this.classList.add('left-sided-submenu');
                childrenMenu.classList.add('left-sided');
              }
            }
            this.classList.add('opened');
            $menu.classList.add('submenu-opened');
          }
        }
      });
      _item.addEventListener('mouseleave', function (e) {
        if (window.innerWidth >= 1024) {
          if (this.classList.contains('opened')) {
            this.classList.remove('opened');
            this.parentNode.classList.remove('left-sided-submenu');
            var submenu = this.querySelector('.sub-menu');
            if (submenu) {
              submenu.classList.remove('left-sided');
            }
            $menu.classList.remove('submenu-opened');
          }
        }
      });
      document.addEventListener('click', function (e) {
        var target = e.target;
        if (target.classList.contains('nav__submenu-title')) {
          target.closest('.nav__item-has-children').classList.remove('opened');
        }
        if (!target.closest('.nav__item-has-children')) {
          var _iterator3 = _createForOfIteratorHelper(submenuItems),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _item2 = _step3.value;
              _item2.classList.remove('opened');
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
})();

},{}],5:[function(require,module,exports){
"use strict";

;
(function ($) {
  $('.grid-events').on('destroy', function (ev, slick) {
    var carousel = $(this),
      reinit = debounce(function () {
        carousel.slick(slick.options);
        window.removeEventListener('resize', reinit);
      }, 500);

    // Assign our debounced callback to window.resize.
    window.addEventListener('resize', reinit);
  }).slick({
    mobileFirst: true,
    slidesToShow: 1,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: 'unslick'
    }]
  });
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
})(jQuery);

},{}],6:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// add target blank to external links
var siteUrl = window.location.hostname;
var links = document.querySelectorAll('a[href*="//"]:not([href*="' + siteUrl + '"])');
var _iterator = _createForOfIteratorHelper(links),
  _step;
try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var elem = _step.value;
    elem.setAttribute('target', '_blank');
    elem.setAttribute('rel', 'noopener noreferrer');
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

},{}]},{},[1]);
